import type { ReactNode } from 'react';
import { Link } from './Link.tsx';

export function PageHead({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="page-head">
      <h1>{title}</h1>
      {children && <div className="note">{children}</div>}
    </div>
  );
}

/** A KPI is always a link to the records it is computed from. */
export function Kpi({ label, value, to, basis, negative = false, testId }: { label: string; value: ReactNode; to: string; basis: string; negative?: boolean; testId?: string }) {
  return (
    <Link to={to} className={`kpi ${negative ? 'neg' : ''}`} testId={testId}>
      <span className="kpi-label">{label}</span>
      <strong className="kpi-value">{value}</strong>
      <span className="kpi-basis">{basis} →</span>
    </Link>
  );
}

export function StateTag({ state }: { state: string }) {
  return <span className={`tag st-${state}`}>{state}</span>;
}

export function NotMeasured() {
  return (
    <span className="muted" title="Not measured — never treated as healthy">
      — not measured
    </span>
  );
}

export function Section({ title, children, testId }: { title: string; children: ReactNode; testId?: string }) {
  return (
    <section className="section" data-testid={testId}>
      <h2>{title}</h2>
      {children}
    </section>
  );
}
